import io from 'socket.io-client';

// Extract base URL from API_BASE_URL by removing /api suffix
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://emailportalapi.twilightfinland.eu/api';
const SOCKET_URL = API_BASE_URL.replace('/api', '');

class SocketService {
    constructor() {
        this.socket = null;
    }

    connect(token) {
        if (this.socket) {
            return this.socket;
        }

        this.socket = io(SOCKET_URL, {
            auth: { token },
            transports: ['websocket', 'polling'], // Prioritize websocket
        });

        this.socket.on('connect', () => {
            console.log('Socket connected:', this.socket.id);
        });

        this.socket.on('connect_error', (err) => {
            console.error('Socket connection error:', err);
        });

        return this.socket;
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }
    }

    emit(event, data) {
        if (this.socket) {
            this.socket.emit(event, data);
        }
    }

    on(event, callback) {
        if (this.socket) {
            this.socket.on(event, callback);
        }
    }

    off(event, callback) {
        if (this.socket) {
            if (callback) {
                this.socket.off(event, callback);
            } else {
                this.socket.off(event);
            }
        }
    }

    joinRoom(roomId) {
        this.emit('join_room', roomId);
    }

    sendMessage(roomId, message, type = 'text') {
        this.emit('send_message', { roomId, message, type });
    }

    typing(roomId) {
        this.emit('typing', roomId);
    }

    stopTyping(roomId) {
        this.emit('stop_typing', roomId);
    }
}

const socketService = new SocketService();
export default socketService;
